import { createContext, useContext } from "react";
import { type EdgeInsets, useSafeAreaInsets } from "@-/com.npmjs.react-native-safe-area-context";

/**
 * Safe-area insets of the window that HOSTS modal sheets, captured where the
 * `BottomSheetModalProvider` mounts. A sheet's portal renders at that host, but its `BottomSheet`
 * is declared deep inside the caller's screen — and a native modal / form-sheet screen installs
 * its own `SafeAreaProvider` that reports a top inset of 0. Reading insets at the call site there
 * let full-height sheets slide up under the status bar.
 */
export const BottomSheetHostSafeAreaInsetsContext = createContext<EdgeInsets | null>(null);

/** The sheet host's insets, falling back to the caller's own when no provider captured them. */
export function useBottomSheetHostSafeAreaInsets(): EdgeInsets {
  const callerInsets = useSafeAreaInsets();
  return useContext(BottomSheetHostSafeAreaInsetsContext) ?? callerInsets;
}
